<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @imp="imp" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<el-tabs :tab-position="'top'" type="" style="margin-top: 0px"  @tab-click="selectInfo">
				<el-tab-pane :label="$t('getapi[6527]')" name="0" id="xpane-0">
				<div style="display: flex;">
					<el-button type="primary" size="mini" :disabled="!btn.arrive" @click="arrive">{{$t('getapi[1622]')}}</el-button>
				</div>
				<!--<wTable :data="dataSet" :loading="loading" :header="tableHeader"
						queryData="SalLogiticsNotNullViewInfo"
						:filter_thousandth="['qty','Net_Amount']"
						@handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>-->

					<vTable
							:data="dataSet"
							:loading="loading"
							queryData="SalLogiticsNotNullViewInfo"
							:filter_thousandth="['qty','Net_Amount']"
							:header="tableHeader"
							:height="tableH"
							@handleSelectionChange="handleSelectionChange"
							@handleSelectionChangeAll="handleSelectionChangeAll"
							@handleSelectionChangeEnd="handleSelectionChange"
							ref="singleTable"
					></vTable>
				</el-tab-pane>
				<el-tab-pane :label="$t('getapi[1622]')" name="1" id="xpane-1">
				<div style="display: flex;">
				<el-button type="primary" size="mini" :disabled="!btn.change" @click="change">{{$t('getapi[6528]')}}</el-button>
				</div>
				<!--<wTable :data="dataSet2" :loading="loading" :header="tableHeader2"
						queryData="SalLogiticsNullViewInfo"
						:filter_thousandth="['qtyda','net_amountda']"
						@handleSelectionChange="handleSelectionChangeM" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"></wTable>-->
					<vTable
							:data="dataSet2"
							:loading="loading"
							queryData="SalLogiticsNullViewInfo"
							:filter_thousandth="['qtyda','net_amountda']"
							:header="tableHeader2"
							:height="tableH"
							@handleSelectionChange="handleSelectionChangeM"
							@handleSelectionChangeAll="handleSelectionChangeMAll"
							@handleSelectionChangeEnd="handleSelectionChangeM"
							ref="singleTable1"
					></vTable>
				</el-tab-pane>
				</el-tabs>
			
			</li>
			</ul>
			<el-row v-if="SelectIndexs == 0" class="page">
				<el-col :span="18" >
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
			<el-row v-if="SelectIndexs == 1" class="page">
				<el-col :span="18" >
					<el-pagination
						@size-change="handleSizeChangeM"
						@current-change="handleCurrentChangeM"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize2"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total2"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames2 }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SalLogiticsNotNullViewInfo" ref="ser" @getser="serclick"></serce>
		<serce :isVisible="isVisible" queryData="SalLogiticsNullViewInfo" ref="serr" @getser="serclick2"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[1028]')" queryData="SalLogiticsNotNullViewInfo" tabNo="0" ref="ctab" @getctab="sortclick(0)"></ctable>
		<ctable :isVisible="false" :title="$t('getapi[1028]')" queryData="SalLogiticsNullViewInfo" tabNo="0" ref="ctabM" @getctab="sortclick(1)"></ctable>
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[4053]')" :visible.sync="dialogVisible" width="20%">
			<div class="bbl">
			<span>{{$t('getapi[6529]')}}</span>
			<el-date-picker v-model="thismonth" popper-class="select-option" type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('getapi[6428]')" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>

		<!-- 数量调整 -->
		<!-- {
		Exclusively_i": 191,
		Delivery_order_no: "00027259",
		Delivery_Line_No: 2,
		CO_Order_No: "ym5903",
		CO_Line_No: 2,
		part_code: "HW123",
		part_version: "A",
		qty: 1,
		Cargo_position: "SSB",
		Net_Amount: 85.47,
		Container_No: "ym5903-1",
		Customer_item: null,
		NewQty: 0

		Exclusively_id
		Delivery_order_no
		Delivery_Line_No
		CO_Order_No
		CO_Line_No
		part_code
		part_version
		qty
		Cargo_position
		Net_Amount
		Container_No
		Customer_item
		NewQty
		} -->
		<el-dialog v-dialogDrag :title="$t('getapi[6528]')" :visible.sync="dialogVisible2" width="90%">
				<el-table
				:data="dataSet5"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight - 200"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:5px"
				>
				<el-table-column show-overflow-tooltip prop="Delivery_order_no" :label="$t('getapi[2292]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Delivery_Line_No" :label="$t('getapi[8183]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="CO_Order_No" :label="$t('getapi[1889]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="CO_Line_No" :label="$t('getapi[1586]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[3101]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="NewQty" :label="$t('getapi[8784]')" align="right">
				<template scope="scope">
				<el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="scope.row.NewQty" ></el-input>
				</template>
				</el-table-column>
				<el-table-column show-overflow-tooltip prop="Cargo_position" :label="$t('getapi[1957]')"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Net_Amount" :label="$t('getapi[2102]')" align="right"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Container_No" :label="$t('getapi[2283]')"></el-table-column>
				</el-table>
			
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible2 = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="copyconfirm2">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'sendexpress',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        },
        tableH(){
            return this.$windowSize.tableHeight3 - Common.reduceTableHeight1_1
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dialogVisible2: false, //时间选择弹框
			dataSet: [], // 主表数据
			dataSet2: [], // 主表数据
			dataSet5:[],
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			queryData2: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			DbTbNames2: '',
			DbTbNames5: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('sendexpress'), // 当前页数据量
			pageIndex2: 1, // 当前页
			pageSize2: this.$http.getPageSize('sendexpress2'), // 当前页数据量
			pageIndex5: 1, // 当前页
			pageSize5: 100, // 当前页数据量
			SelectIndexs: 0, //当前页面
			total: 0, // 数据总量
			total2:0,
			total5:0,
			thismonth:'',
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			tableHeader2: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectIDListM: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				arrive: false,
				//删除
				change: false,
			},
            scrollTop:0,
            scrollTop1:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
        dataSet2: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(1)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
		that.thismonth = that.$limits.getDateTime();
	
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
            that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
            }, 13)
        })
    },
	methods: {
		arrive(){
			let that = this;
			that.dialogVisible = true;
		},
		change(){
			let that = this;
			that.dialogVisible2 = true;
			that.getViewD();
		},
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogiticsNotNullViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		colsort2(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogiticsNullViewInfo',0,PFileds=>{
			that.tableHeader2=PFileds;		
		});	
		},
		sortclick(val){
			if(val==0){
				this.colsort();
			}else{
				this.colsort2();
			}
		},
		selectInfo(tab, event) {
		let that = this;
		that.SelectIndexs = tab.name;
		if(that.SelectIndexs==0){
			that.colsort();
		}else{
			that.colsort2();
		}
		that.getView();
            that.$nextTick(function() {
                that.$processdata.initForm(that.SelectIndexs)
            })
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1028]"),this.$t("getapi[14]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			console.log(that.$limits.OperationAuthorityView('plv2', 373, 1, that.total))
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 373, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			limits = that.$limits.OperationAuthorityView('plv2', 373, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
					break;
				default:
					break;
			}
			if(limits==-1||limits==1)that.closeAllRightButton();
            else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.copy = false;
			that.btn.delete = false;
			if (that.$limits.authority('plv4', 62, 1) == 1) {
				that.btn.copy = true;
			} 
			if (that.$limits.authority('plv4', 93, 1) == 1) {
				that.btn.delete = true;
			} 
		},
		closeAllRightButton(){
			let that =this;
			that.btn.copy = false;
			that.btn.delete = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange({checked, records }) {
		let that = this;
		that.selectIDList=records;
		if(that.selectIDList.length>0){
            if (that.$limits.authority('plv4', 374, 1) == 1){
                that.btn.arrive = true;
			} else {
                that.btn.arrive = false
			}
        }
		else that.btn.arrive = false;
		},
        handleSelectionChangeAll({records }) {
            let that = this;
            that.selectIDList=records;
            if(that.selectIDList.length>0){
                if (that.$limits.authority('plv4', 374, 1) == 1){
                    that.btn.arrive = true;
                } else {
                    that.btn.arrive = false
                }
            }
            else that.btn.arrive = false;
        },
		handleSelectionChangeM({checked, records }) {
		let that = this;
		that.selectIDListM=records;
		if(that.selectIDListM.length>0){
            if (that.$limits.authority('plv4', 383, 1) == 1){
                that.btn.change = true;
            } else {
                that.btn.change = false;
			}
        }
		else that.btn.change = false;
		},
        handleSelectionChangeMAll({records }) {
            let that = this;
            that.selectIDListM=records;
            if(that.selectIDListM.length>0){
                if (that.$limits.authority('plv4', 383, 1) == 1){
                    that.btn.change = true;
                } else {
                    that.btn.change = false;
                }
            }
            else that.btn.change = false;
        },
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('sendexpress',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},

		handleSizeChangeM(val) {
			this.pageSize2 = val;
            this.$http.savePageSize('sendexpress2',val)
			this.getView();
			this.authority();
		},
		handleCurrentChangeM(val) {
			this.pageIndex2 = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			if(that.SelectIndexs==0){
			that.$refs.ser.clearInput(that.isVisible, 'SalLogiticsNotNullViewInfo');
			}else{
			that.$refs.serr.clearInput(that.isVisible, 'SalLogiticsNullViewInfo');
			}
			
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		//获取查询条件
		serclick2(val) {
			this.queryData2 = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
            that.pageIndex2 = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];

			if(that.SelectIndexs==0){
				for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
				query_Condition: that.queryData[i].query_Condition,
				query_field_type: that.queryData[i].Query_Field_Type,
				query_field_name: that.queryData[i].Query_Field_Name,
				query_sort: that.queryData[i].query_sort,
				row_sign: that.queryData[i].row_sign
				});
				}
			}else{
				for (let i = 0; i < that.queryData2.length; i++) {
				datac.push({
				query_Condition: that.queryData2[i].query_Condition,
				query_field_type: that.queryData2[i].Query_Field_Type,
				query_field_name: that.queryData2[i].Query_Field_Name,
				query_sort: that.queryData2[i].query_sort,
				row_sign: that.queryData2[i].row_sign
				});
				}
			}
			let tmpindex = that.pageIndex;
			let tmpsize = that.pageSize;
			if(that.SelectIndexs==1){
			tmpindex = that.pageIndex2;
			tmpsize = that.pageSize2;
			}
			let data = {
				PageIndex: tmpindex,
				PageSize: tmpsize,
				Param: datac
			};
			let purl = '/Sal/Tru/TruMovingViewDataList';
			if(that.SelectIndexs==1)purl = '/Sal/Tru/TruConsignmentViewDataList';
			that.$http.urlpost(purl, data, function(res) {
				if (res.Success == 1) {
					if(that.SelectIndexs==0){
						that.dataSet = res.DataContent;
						that.total = res.Totals;
						that.loading = false;
						that.DbTbNames = res.DbTbNames;
					}else{
						that.dataSet2 = res.DataContent;
						that.total2 = res.Totals;
						that.loading = false;
						that.DbTbNames2 = res.DbTbNames;
					}
				}
				that.authority();
			});
		},
		// 数据一览
		getViewD() {
			let that = this;
			that.loading = true;
			let token = JSON.parse(that.userData).token;
			let dataj={
			PageIndex: that.pageIndex5,
			PageSize: that.pageSize5,
			SelectIndex: 0,
			Ids: "",
			Param: []
			}
			for(let i=0;i<that.selectIDListM.length;i++){
				let obj = {
				Exclusively_id: that.selectIDListM[i].exclusively_idda,
				Qty: 0
				}
				dataj.Param.push(obj);
			}
			that.$http.urlpost('/Sal/Tru/GetUpdateQtyDataList', dataj, function(res) {
				if (res.Success == 1) {
					that.dataSet5 = res.DataContent;
					that.total5 = res.Totals;
					that.DbTbNames5 = res.DbTbNames;
					
				}
				that.loading = false;
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false;
			let OrderList = [];
			for (let i = 0; i < that.selectIDList.length; i++) {
				OrderList = [
					...OrderList,
					{
						Delivery_Order_No: that.selectIDList[i].Delivery_order_no
					}
				];
			}

			let parm = {
				Lists: OrderList,
				Daoda_Date: that.thismonth,
				LangType: that.$processdata.getLang(),
			}
			that.$http.urlpost('/Sal/Tru/ExecuteDaoDa', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
					that.getView();
				}
				that.btn.arrive = true;
				that.dialogVisible = false;
			});


		},
		copyconfirm2(){
			//  
			let that = this;
			if(that.dataSet5.length==0){
				that.dialogVisible = false;
				return;
			}
			let parm = [];
			for(let i=0;i<that.dataSet5.length;i++){
				if(that.dataSet5[i].NewQty==0){
					that.$message.warning(that.$t('getapi[8183]')+':'+that.dataSet5[i].Delivery_order_no+that.$t('getapi[8183]')+':'+that.dataSet5[i].Delivery_Line_No+that.$t('getapi[1659]'));
					return;
				}
				let obj =   {
				Exclusively_id: that.dataSet5[i].Exclusively_id,
				Qty: that.dataSet5[i].NewQty
				}
				parm.push(obj);
			}
			that.$http.urlpost('/Sal/Tru/ExecuteUpdateQty', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.dialogVisible2 = false;
			});

		},
		deleteline(){
			let that = this;
			that.btn.delete = false;
			let token = JSON.parse(that.userData).token;
			let geturl = Common.Url + 'Inv/PartCost/InvPartStdCostDeleteCost?costID='+that.selectIDList[0].Exclusively_Id+'&token=' + token;
			that.$http.gets(geturl, '', function (res) {
			if (res.data.Success == 1) {
				that.$message.success(res.data.Msg);
				that.getView();
			}else{
				that.$message.warning(res.data.Msg);
			}
			that.btn.delete = true;
			});

		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndexs,
				Ids: '',
				Param: datac
			};
			let purl = '/Sal/Tru/TruMovingViewExportToExecl';
			if(that.SelectIndexs==1)purl = '/Sal/Tru/TruConsignmentViewExportToExecl';
			that.$http.urlpost(purl, parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
        imp(){
            let item = {
                label: this.$t('getapi[8962]'),
                name: 'sendexpressimp',
                path: '/sendexpressimp',
                url: 'menu1/sales/wt/sendexpressimp',
                icon: 'video-play'
            };
            this.$router.push({path: '/sendexpressimp'});
            this.$store.commit('selectMenu', item);
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
